package one.healthium.tasks.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class DailyTaskInfoDto(
    @SerialName("type") val type: String,
    @SerialName("title") val title: String,
    @SerialName("color") val color: String? = null,
    @SerialName("insight_id") val insightId: String? = null,
    @SerialName("workout_id") val workoutId: String? = null,
)
